import { useI18n } from '@i18n/useI18n';
import { useEffect, useState } from "react";
import { ActionBar, BContent, Bottom, BTop, Lecture, Middle, PillContainer, PlanedAbsenceBlockContainer, TagPill, Top } from "./PlanedAbsenceBlock.styled";
import Calender_Icon from "@assets/svg/calendar.svg";
import Delete_Icon from "@assets/svg/trashcan_icon.svg";
import Edit_Icon from "@assets/svg/edit_icon.svg";
import Chev_Icon from "@assets/svg/chevron-down.svg";
import Lecture_Icon from "@assets/svg/lecture.svg";
import lipsum, { partialLipsum } from "@utils/lipsum";
import moment from "moment";
import { TagPills } from "@components/Note/Message/Message.styled";
import Tooltip from "@components/Tooltips/Tooltip";

interface IProps {
    absenceId: number,
    date: string,
    text: string,
    timeblocks: any,
    tags: any,
    days: any,
    delete?: (id) => void,
    edit?: (event) => void
}

const PlanedAbsenceBlock = (props: IProps) => {
    const i18n = useI18n();
    const [show, setShow] = useState(null)

    useEffect(() => {
        let s = Object.keys(props.days).map((s,i) => Object.keys(props.days).length === 1?true:false )
        setShow(s)
    }, [props.days])

    const handleOpen = (index) => {
        let s = JSON.parse(JSON.stringify(show))
        if(s)s[index] = !s[index]
        setShow(s)
    }

    return (
        <PlanedAbsenceBlockContainer>
            <Top>
                <Calender_Icon />
                <span>{props.date}</span>

                <ActionBar>
                    <Tooltip content={i18n.t('edit-scheduled')} offsetY={-6}>
                        <button onClick={() => props.edit({absenceId: props.absenceId, date: props.date, text: props.text, timeblocks: props.timeblocks, days: props.days, tags: props.tags})}>
                            <Edit_Icon />
                        </button>
                    </Tooltip>

                    <Tooltip content={i18n.t('delete-scheduled')} offsetY={-6}>
                        <button onClick={() => props.delete(props.absenceId)}>
                            <Delete_Icon />
                        </button>
                    </Tooltip>
                </ActionBar>
            </Top>
            {props.text?.length > 0 &&
                <Middle>
                    <p>{props.text}</p>
                </Middle>
            }
            <PillContainer>
                {props.tags.map((t, index) => {
                    return <TagPill key={props.absenceId + "_tagpill_" + index} bgColor={t.html_color}>{i18n.t("tag-" + t.name)}</TagPill>
                })}
            </PillContainer>

            <Bottom>
                {Object.keys(props.days).map((key, index) => <>
                    <BTop onClick={() => handleOpen(index)} open={!(show && show[index] === true)}>
                    <Calender_Icon />
                    <span>{moment(key).format("DD MMMM YYYY")}</span>
                    <span>{props.days[key].length > 1?i18n.t("note-lessons"):i18n.t("note-lesson")} ({props.days[key].length})</span>
                    <Chev_Icon />
                </BTop>
                <BContent open={show && show[index] === true}>
                    {props.days[key].map((l, index) => {
                        return <Lecture key={props.absenceId + "_lectureblock_" + index}>
                            <span><b>{l.starttime}</b> - <b>{l.endtime}</b></span>
                            <span>{l.displayname}</span>
                        </Lecture>
                    })}
                </BContent>
                </>)}
            </Bottom>

        </PlanedAbsenceBlockContainer>
    )
}

export default PlanedAbsenceBlock;